var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-cancel"},[_c('div',{staticClass:"cancel-container"},[_c('h2',[_vm._v("Payment Cancelled")]),_c('div',{staticClass:"cancel-message"},[_c('p',[_vm._v("You have cancelled the payment process.")]),_c('p',[_vm._v("You ll be redirect to your Rapport employee page.")])])])])
}]

export { render, staticRenderFns }